import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import { useConfiguration } from '~/contexts';
import { fetchTranslations } from '~/utils';

export type ResultData = Awaited<ReturnType<typeof fetchTranslations>>;

export function useLocalizationQuery(config?: SWRConfiguration<ResultData, Error>) {
  const { currentLanguage, tenant, staticApiUrl } = useConfiguration();

  return useSWR([currentLanguage, tenant, staticApiUrl], fetchTranslations, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    ...config,
  });
}
